export default (params) => ({
  trigger: {
    name: 'alternative_primary_item.select_all_alternatives_below_element',
    params: params,
  },
  config: {
    schema: {
      content: {
        type: 'string',
      },
    },
    event: {
      name: 'select_all',
      params: {
        sub_feature: 'below_element',
      },
    },
  },
});
